import { useContext } from 'react';

import classnames from 'classnames';

import { NavBarLinks } from './SellerNavBar.helpers';
import styles from './SellerNavBar.module.css';
import { ActivationContext } from '../../../activation/Activation';
import { NavBarLink } from '../NavBarLink';

export const SellerNavBarItems = ({ className }: { className?: string }) => {
  const { isOnboarded } = useContext(ActivationContext);

  const navBarLinks = NavBarLinks(isOnboarded);
  const newTabProps = {
    target: '_blank',
    rel: 'noopener noreferrer',
  };

  return (
    <div
      data-testid="navBarLeftPane"
      className={classnames(styles.desktopNavBarItems, className)}
    >
      {navBarLinks.map((navBarItem) => {
        return (
          <SellerNavBarLink
            key={navBarItem.label}
            to={navBarItem.link}
            isExternalLink={navBarItem?.isExternalLink}
            {...(navBarItem.opensNewTab && newTabProps)}
            className={navBarItem.className ? styles[navBarItem.className] : ''}
          >
            {navBarItem.label}
          </SellerNavBarLink>
        );
      })}
    </div>
  );
};

const SellerNavBarLink = ({
  to,
  children,
  className,
  isExternalLink,
  ...props
}: {
  to: string;
  children: React.ReactNode;
  className?: string;
  isExternalLink?: boolean;
}) => {
  return (
    <NavBarLink
      {...props}
      className={classnames(className, styles.navBarAnchor, styles.noButton)}
      activeClass={styles.navBarAnchorActive}
      to={to}
      isExternalLink={isExternalLink}
    >
      {children}
    </NavBarLink>
  );
};
